module.exports = __webpack_public_path__ + "media/packs/fonts/IsidoraSans-Bold-c5f6fd16c2e7361df72ab67ac1ce7721.woff2";